module.exports = __webpack_public_path__ + "static/media/logo.d0d21a41.png";